<template>
  <div>
    <bi-button label="计量单位配置" type="gley" @click="handleSetUnit" v-if="blueLineBtn"/>
    <div v-else class="set-unit-container" @click="handleSetUnit">
      <img :src="setUnitIcon" class="set-unit-icon" />
      <bi-button label="计量单位配置" type="text" />
    </div>
    <el-dialog
      title="计量单位配置"
      width="700px"
      :visible="showSetUnitModal"
      :close-on-click-modal="false"
      destroy-on-close
      @close="handleCancel"
    >
      <div>
        <bi-tip> 注：【启用】后报表会展示该计量单位 </bi-tip>
        <el-form
          ref="formData"
          inline
          label-width="auto"
          style="margin-top: 16px"
        >
          <el-form-item label="计量单位统计是否开启:" required>
            <el-radio-group v-model="formData.measureUnitIsEnable">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择计量单位:" required>
            <el-select
              v-model="formData.measureUnitId"
              placeholder="请选择计量单位"
            >
              <el-option
                v-for="item in measureUnitList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <span
              style="margin-left: 8px"
              class="clickable-link"
              @click="goSetUnit()"
              >去设置>></span
            >
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="footerBtnBox">
          <bi-button @click="handleSure" type="blue">确定</bi-button>
          <bi-button @click="handleCancel" type="gley">取消</bi-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import setUnitIcon from "@/assets/images/report/setUnit.svg";
import {
  querySectionConfig,
  saveSectionConfig,
  getQueryMeasureUnitList,
} from "@/api/bi/reviewReport/sectionConfig.js";

export default {
  props: {
    sellerId: {
      type: [String, Array],
      default: "",
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    nowShopList: {
      type: Array,
      default: () => [],
    },
    blueLineBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      setUnitIcon,
      showSetUnitModal: false,
      formData: {
        measureUnitIsEnable: 0,
        measureUnitId: "",
        measureUnitName: "",
      },
      measureUnitList: [],
    };
  },
  async mounted() {
    await this.getSectionConfig();
    if(this.blueLineBtn) {
     await this.getMeasureUnitList();
      this.$emit("initUnit", "Unit");
    }
    // await this.getMeasureUnitList();
  },
  watch: {
    sellerId: {
     async handler(newVal, oldVal) {
        if(this.isMultiple) {
          let val1, oldVal1;
          if(oldVal === undefined || newVal === []) {
            return;
          }
          if(newVal instanceof Array && oldVal instanceof Array){
            val1 = newVal.join(',');
            oldVal1 = oldVal.join(',');
          }
          if(val1 == oldVal1 && oldVal && newVal.length == oldVal.length) {
            return;
          }
          if(newVal.length <= 0) {
            return;
          }
          await this.getMeasureUnitList();
          this.$emit("initUnit", "Unit");
        }else{
        if ((newVal != oldVal) && newVal) {
          await this.getMeasureUnitList();
          this.$emit("initUnit", "Unit");
        }
        }
      },
      // immediate: true,
			deep: true,
    },
  },
  methods: {
    // 查询计量单位配置
    async getSectionConfig(type) {
      let res = await querySectionConfig({ type: 23 });
      if (res.code == 1 || res.code == 200) {
        this.formData = JSON.parse(res.data);
        if (!this.formData.measureUnitId) {
          this.formData = {
            measureUnitIsEnable: 0,
            measureUnitId: "",
            measureUnitName: "",
          };
        }
        this.$emit("unitForm", this.formData, false);
        if (type == 1) {
					this.nowData = JSON.parse(JSON.stringify(this.formData))
          this.$emit("setUnit", true);
        }
      }
    },

    async getMeasureUnitList() {
      let params = {
        sellerId: this.sellerId,
      };
      if(this.isMultiple){
        if(!this.sellerId.join(',')){
          params = {
            sellerId: this.nowShopList.join(',') || "",
          }
        }else{
          params = {
            sellerId: this.sellerId.join(',') || "",
          }
        }
      }
      let res = await getQueryMeasureUnitList(params);
      if (res.code == 1 || res.code == 200) {
        this.measureUnitList = res.data;
        if (!this.formData.measureUnitId) {
          this.formData.measureUnitId = res.data[0]?.id || "";
					this.formData.measureUnitName = res.data[0]?.name || "";
          this.$emit("unitForm", this.formData, true);
        } else if (
          !res.data.some((item) => item.id == this.formData.measureUnitId)
        ) {
          this.formData.measureUnitId = res.data[0]?.id || "";
					this.formData.measureUnitName = res.data[0]?.name || "";
					this.$emit("unitForm", this.formData, true);
        }
					this.nowData = JSON.parse(JSON.stringify(this.formData))
      }
    },
    handleSetUnit() {
      this.showSetUnitModal = true;
			this.formData = JSON.parse(JSON.stringify(this.nowData))
    },
    goSetUnit() {
      if (window.location.origin.includes("yqbi.yucrm.cn")) {
        window.open(
          "https://yqbi.yucrm.cn/bi-web/yunzhou-common/system-redirect?redirectUrl=/data_management/item_manage%3Ftips%3DitemUnit",
          "_blank",
        );
      } else {
        window.open(
          "http://yqbi-test.yucrm.cn/bi-web/yunzhou-common/system-redirect?redirectUrl=/data_management/item_manage%3Ftips%3DitemUnit",
          "_blank",
        );
      }
      return;
    },
    handleSure() {
      let data = {
        measureUnitIsEnable: this.formData.measureUnitIsEnable,
        measureUnitId: this.formData.measureUnitId,
        measureUnitName: this.measureUnitList.find(
          (item) => item.id == this.formData.measureUnitId,
        ).name,
      };
      let params = {
        type: 23,
        data: JSON.stringify(data),
      };
      saveSectionConfig(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.getSectionConfig(1);
          this.showSetUnitModal = false;
        }
      });
    },
    handleCancel() {
      this.showSetUnitModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.set-unit-container {
  display: flex;
  align-items: end;
  cursor: pointer;
  .set-unit-icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
}
.clickable-link {
  color: #2768ff;
  text-decoration: underline;
  cursor: pointer;
}
.footerBtnBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
</style>
